// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"e377dd0d","105":"91b07fb2","274":"04c8d4ee","446":"248cfe28"}[chunkId] + ".chunk.js";
};